import { OrderFields } from "../../../constants";
import type { TOrderFormData } from "../../../models/orderForm";
import type { TPrefillInfoParams } from "./types";

const getPrefillSenderData = ({ affiliate, userAddress, storedData }: TPrefillInfoParams): Partial<TOrderFormData> => {
  // Not prefilling default user address if there is stored different country
  const storedStartingCountry = storedData?.[OrderFields.STARTING_COUNTRY];
  const filteredUserAddress =
    !storedStartingCountry || userAddress?.countryCode === storedStartingCountry ? userAddress : null;

  const valuesToPrefill: Partial<TOrderFormData> = {
    [OrderFields.SENDER_NAME]: storedData?.[OrderFields.SENDER_NAME] ?? filteredUserAddress?.contactName,
    [OrderFields.SENDER_PHONE_NUMBER]:
      storedData?.[OrderFields.SENDER_PHONE_NUMBER] ?? filteredUserAddress?.contactPhone,
    [OrderFields.SENDER_EMAIL]: storedData?.[OrderFields.SENDER_EMAIL] ?? filteredUserAddress?.contactEmail,
    [OrderFields.RETURN_LOCKER]:
      storedData?.[OrderFields.RETURN_LOCKER] ?? affiliate?.returnLockerId ?? filteredUserAddress?.returnLockerId,
    [OrderFields.RETURN_LOCKER_NAME]:
      storedData?.[OrderFields.RETURN_LOCKER_NAME] ??
      affiliate?.returnLocker ??
      filteredUserAddress?.returnLocker?.name,
    [OrderFields.SENDER_STREET]: storedData?.[OrderFields.SENDER_STREET] ?? filteredUserAddress?.street,
    [OrderFields.SENDER_HOUSE_NO]: storedData?.[OrderFields.SENDER_HOUSE_NO] ?? filteredUserAddress?.streetNumber,
    [OrderFields.SENDER_FLAT_NO]: storedData?.[OrderFields.SENDER_FLAT_NO] ?? filteredUserAddress?.flatNo,
    [OrderFields.SENDER_CITY]: storedData?.[OrderFields.SENDER_CITY] ?? filteredUserAddress?.city,
    [OrderFields.SENDER_ZIP_CODE]: storedData?.[OrderFields.SENDER_ZIP_CODE] ?? filteredUserAddress?.zip,
    [OrderFields.SENDER_COMMENTS]: storedData?.[OrderFields.SENDER_COMMENTS],

    [OrderFields.LABEL_PRINT]: storedData?.[OrderFields.LABEL_PRINT],
    [OrderFields.PICKUP_DATE]: storedData?.[OrderFields.PICKUP_DATE],
    [OrderFields.PICKUP_TIME_FROM]: storedData?.[OrderFields.PICKUP_TIME_FROM],
    [OrderFields.PICKUP_TIME_TILL]: storedData?.[OrderFields.PICKUP_TIME_TILL],
    [OrderFields.SENDER_AS_CONTACT_PERSON]: storedData?.[OrderFields.SENDER_AS_CONTACT_PERSON],
    [OrderFields.CONTACT_PERSON_NAME]: storedData?.[OrderFields.CONTACT_PERSON_NAME],
    [OrderFields.CONTACT_PERSON_PHONE_NUMBER]: storedData?.[OrderFields.CONTACT_PERSON_PHONE_NUMBER],
    [OrderFields.CONTACT_PERSON_EMAIL]: storedData?.[OrderFields.CONTACT_PERSON_EMAIL],
  };
  return valuesToPrefill;
};
export default getPrefillSenderData;
